import { motion } from "framer-motion";
import { Clock } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

export const Hours = () => {
  const { t } = useLang();

  const rows = [
    { label: t.hours.monfri, time: t.hours.monfri_time, open: true },
    { label: t.hours.sat, time: t.hours.sat_time, open: false },
    { label: t.hours.sun, time: t.hours.sun_time, open: false },
  ];

  return (
    <section
      id="hours"
      className="relative py-24 md:py-32 bg-[#070707]"
      data-testid="hours-section"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-14"
        >
          <div className="inline-flex items-center gap-4 mb-6">
            <Clock size={16} className="text-[#C5A059]" strokeWidth={1.5} />
            <span className="text-xs uppercase tracking-[0.3em] text-[#C5A059]">
              {t.hours.eyebrow}
            </span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-white">
            {t.hours.title}
          </h2>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={{
            hidden: {},
            show: { transition: { staggerChildren: 0.12 } },
          }}
          className="max-w-2xl mx-auto divide-y divide-white/10 border-y border-white/10"
        >
          {rows.map((r, i) => (
            <motion.div
              key={i}
              variants={{
                hidden: { opacity: 0, x: -20 },
                show: { opacity: 1, x: 0, transition: { duration: 0.6 } },
              }}
              className="flex items-center justify-between py-6 md:py-7"
              data-testid={`hours-row-${i}`}
            >
              <span className="font-display text-xl md:text-2xl text-white">
                {r.label}
              </span>
              <span
                className={`text-sm md:text-base uppercase tracking-[0.2em] ${
                  r.open ? "text-[#C5A059]" : "text-white/35"
                }`}
              >
                {r.time}
              </span>
            </motion.div>
          ))}
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mt-10 text-center text-sm text-white/40 font-light italic max-w-xl mx-auto"
        >
          {t.hours.note}
        </motion.p>
      </div>
    </section>
  );
};
